export default __webpack_public_path__ + "static/media/gallery - story - heart (1)_01.e8fe83fb.jpg";